import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Company } from './types';
import isEqual from 'react-fast-compare';
import { useParams } from 'react-router';
import { useQuery,queryCache } from "react-query";
import Spinner from '@atlaskit/spinner';
import api from 'libs/api';
import { getCurrentCompany } from '../../libs/auth';

export const CurrentCompanyContext = React.createContext<Company | null>(null);

const fetchCompany = async (key:string, companySlug: string) => {
  console.log('fetch company companySlug: ',companySlug);
  const data = await api.get(`/Companies/${companySlug}`);
  return data;
};

export const CurrentCompanyProvider: React.FC = ({ children }) => {
  let {companySlug} = useParams();
  // console.log('companySlug',companySlug );
  companySlug = getCurrentCompany().slug; // TEMP fix due to delay angular router and react router (else company-slug is "login" for a brief moment)

  const { data, error, isLoading } = useQuery(['company', companySlug], fetchCompany);
  // const channel = useChannel("presence-channel");
  // const trigger = useClientTrigger(channel);

  useEffect(()=> {
    console.log('Clear use-query cache, because company changed');
    const queries = queryCache.removeQueries((query:any) => {
      return !query.queryKey[0].match(/company|user/);
    })
    // trigger("client-current-company", { currentCompanySlug: companySlug });

  }, [companySlug]);

  // useEvent(channel, "client-current-company-request", (event : any) => {
  //     console.log('client-current-company-request', companySlug);
  //     trigger("client-current-company", { currentCompanySlug: companySlug });
  //   }
  // );


  // console.log('Current company is', data);

  return (
    <CurrentCompanyContext.Provider
      value={data}
    >
      {isLoading? <Spinner/> : children}
    </CurrentCompanyContext.Provider>
  );
};

export const useCurrentCompany = () => React.useContext(CurrentCompanyContext);

